export default "__VITE_ASSET__4181be52__"